export default "__VITE_ASSET__C6JxMD7I__"